import toast from 'react-hot-toast';
import { Box } from '@xstyled/styled-components';
import { toastStyles } from './toastStyles';
import { FlexBox } from '../Primitives/FlexBox';
import { Heart } from '../Icons';

export default function newItemInWishlistToast({
  item,
  action,
  isDesktop,
  lang
}) {
  const added = action === 'add';

  return toast(
    () => (
      <FlexBox as="span" align="center" spaceX={16}>
        <Box
          as="span"
          role="img"
          aria-label={`Product ${
            added ? 'added to wishlist' : 'removed from wishlist'
          }`}
        >
          <Heart fill={added ? '#fe93bf' : 'none'} />
        </Box>
        <span>
          {lang === 'et' ? 'Toode' : 'Product'} <b>{item}</b>{' '}
          {added
            ? lang === 'et'
              ? 'lisatud lemmikutesse'
              : 'added to favourites'
            : lang === 'et'
            ? 'eemaldatud lemmikutest'
            : 'removed from favourites'}
        </span>
      </FlexBox>
    ),
    { styles: toastStyles({ isDesktop, background: '#FFF' }) }
  );
}
